import Link from "next/link";
import React from "react";
export type BreadcrumbItem = {
  label: string;
  href?: string;
  icon?: React.ReactNode;
  className?: string;
};
type BreadcrumbProps = {
  items: BreadcrumbItem[];
};
const Breadcrumb: React.FC<BreadcrumbProps> = ({
  items
}) => {
  return <div className="flex w-fit flex-row flex-wrap items-center rounded-xl bg-background p-2 px-5 text-primary shadow-md dark:bg-secondary dark:text-secondary-foreground " data-sentry-component="Breadcrumb" data-sentry-source-file="breadcrumbs.tsx">
      {items.map((item, index) => {
      const IconComponent = item.icon;
      return <React.Fragment key={item.label}>
            <Link href={item?.href || "#"} className={`my-1 flex w-max items-center gap-3 rounded-3xl px-3 py-1 text-base no-underline transition hover:bg-secondary active:scale-95 dark:hover:bg-background ${item.className || ""}`}>
              {IconComponent && <span className="flex items-center">{IconComponent}</span>}
              {item.label}
            </Link>
            {index < items.length - 1 &&
        // eslint-disable-next-line @shopify/jsx-no-hardcoded-content
        <span className="mx-4 text-base dark:bg-secondary/80 dark:text-secondary-foreground/80">
                /
              </span>}
          </React.Fragment>;
    })}
    </div>;
};
export default Breadcrumb;